var mobile, ios, android, touchDevice;
var carousel, screenSize = 'wide-screen';
var days, hrs, mins, timer;
var carouselInitAttempts = 0;


/* Initialize */

function initialize() {
    createMobileNavigation();
    if ($('.carousel').length) createCarousel();

    // Smooth scroll for anchor links
    $('a[href^=\\#]').click(function (e) {
        var anchor = $(this).attr('href');
        if (anchor.length > 1) {
            e.preventDefault();
            scrollToSection(anchor);
            return false;
        }
    });

    //// Choose color and specs
    //$('#choose-btn').click(function(e)
    //{
    //	e.preventDefault();
    //	var color = $('#color-name').text();
    //	var image = $(this).attr('data-image');
    //	$('.specs-image img').attr('src', image);
    //	$('.specs-image img').eq(1).attr('src', image.replace('option-3', 'option-2'));
    //	$('.specs-image img').eq(0).attr('src', image.replace('option-3', 'option-1'));
    //	$('.specs-cta .cta-btn').attr('data-color', color);
    //	$('#choose-option #step-1').stop().fadeOut(200, function()
    //	{
    //		$('#choose-option #step-2').stop().fadeIn(250);
    //		resizeSpecsTable();
    //		scrollToSection('#choose-option', 500, (mobile ? 70 : 12));
    //       });

    //       //save color selection in GA Event
    //       SetGaEventTracking('Color Selection', 'Click', color);

    //});
    $('#back-to-color-btn').click(function (e) {
        e.preventDefault();
        $('#choose-option #step-2').stop().fadeOut(200, function () {
            $('#choose-option #step-1').stop().fadeIn(250);
        });
    });
    $('.specs-cta .cta-btn').click(function (e) {
        e.preventDefault();
        var color = $(this).attr('data-color');
        var spec = $(this).attr('data-spec');
        SetGaEventTracking('Spec Selection', 'Click', spec);

        //give 1 second to properly execute the GA event tracking code before redirecting to other page.
        setTimeout(function () {
            var redirectLocation = '/order?color=' + color + '&spec=' + spec;

            //START: redirect to shopify page based on color selection
            redirectLocation = "";
            switch (color) {
                case "Starry Night":
                    {
                       // redirectLocation = "https://shop.santithesloth.com/products/santi-the-sloth?variant=30993870291006";
                        redirectLocation = "https://shop.santithesloth.com/products/santi-the-sloth-starry-night";
                        break;
                    }
                case "Stardust":
                    {
                        //redirectLocation = "https://shop.santithesloth.com/products/santi-the-sloth?variant=30993870323774";
                      redirectLocation = "https://shop.santithesloth.com/products/santi-the-sloth";
                        break;
                    }
                case "Cherry Blossom":
                    {
                        redirectLocation = "https://shop.santithesloth.com/products/santi-the-sloth-cherry-blossum";
                        break;
                    }
                default:
                    {
                        redirectLocation = "https://shop.santithesloth.com/products/santi-the-sloth";
                        break;
                    }
            }
            //END: redirect to shopify page based on color selection

            window.location.href = redirectLocation;
        }, 1000);
    });

    // Back to top button
    $('.back-to-top').click(function (e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 1000, 'swing');
    });

    // Start countdown
    if ($('.site-notification').length) {
        $('.reminder').html($('.site-notification').html());
        days = Number($('.site-notification #days span').text());
        hrs = Number($('.site-notification #hrs span').text());
        mins = Number($('.site-notification #mins span').text());
        timer = setInterval(countdown, 60000);
    }

    //form submission with Recaptcha V2
    $('.contact-form-button').click(function (e) {
        e.preventDefault();

        var submitButton = this;

        var formObj = $(submitButton).closest("form");

        //var formObj = $(this).parent();

        validateCaptcha();
        if ($(formObj).valid() && validateCaptcha()) {

            if (recaptchaResponse.length != 0) {

                //show processing button
                $(submitButton).hide();
                $(submitButton).siblings(".btn-disable").show();

                //setTimeout(function () {

                //    var url = "/umbraco/api/RecaptchaValidatorApi/ValidateRecaptchaResposne?token=" + recaptchaResponse;

                //    $.post(url, function (response) {
                //        //alert(response);
                //        console.log(response);
                //        if (response) {
                $(formObj).submit();
                //        }
                //        else {
                //            alert("Invalid re-captcha, Please try again.");
                //            $(submitButton).show();
                //            $(submitButton).siblings(".btn-disable").hide();
                //            console.log(response);
                //        }
                //    });


                //}, 1000);
            }
            else {
                console.log("captcha token not present. try again");
                $(submitButton).show();
                $(submitButton).siblings(".btn-disable").hide();
            }
        }
        else {
            console.log('form is not valid');
            $(submitButton).show();
            $(submitButton).siblings(".btn-disable").hide();
        }

    });

    // Event handlers
    $(window).scroll(scrollHandler);
    scrollHandler();

    $(window).bind(ios ? 'orientationchange' : 'resize', resizeHandler);
    resizeHandler();

    $('html').addClass('initialized');
}

//recaptcha
function validateCaptcha() {
    recaptchaResponse = grecaptcha.getResponse();
    if (recaptchaResponse == "") {
        $('.g-recaptcha').siblings('#recaptcha-validation-error').removeClass('hide');
        return false;
    }
    else {
        $('.g-recaptcha').siblings('#recaptcha-validation-error').addClass('hide');
        return true;
    }
}


/* Create mobile navigation */

function createMobileNavigation() {
    var links = $('#main-menu').html() + $('#cta-bar').html();
    var m_menu = '<div class="m-btn"></div><div class="m-menu"><p class="overlay"></p><div><p class="overlay"></p><ul class="valign">' + links + '</ul><div class="close-btn"></div></div></div>';

    $('#nav-container').append(m_menu);
    $('.m-menu a').removeClass('cta-btn');

    $('.m-btn').click(function () {
        $('.m-menu').addClass('shown');
        $(this).addClass('toggled');
        $('#main, #footer').addClass('locked');
        $('html, body').addClass('freeze');
    });

    $('.close-btn, .m-menu ul a').click(function () {
        $('.m-menu').removeClass('shown');
        $('.m-btn').removeClass('toggled');
        $('#main, #footer').removeClass('locked');
        $('html, body').removeClass('freeze');
    });

    $('.m-menu .overlay').bind('touchstart click', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });
}


/* Create carousel */

function createCarousel() {
    if (typeof $.fn.carousel !== 'function') {
        if (carouselInitAttempts < 10) {
            carouselInitAttempts++;
            setTimeout(createCarousel, 100);
        }
        return;
    }

    carouselInitAttempts = 0;
    carousel = $('.carousel').carousel(
        {
            num: 3,
            maxWidth: 300,
            maxHeight: 750,
            distance: 160,
            scale: 0.6,
            animationTime: 400,
            onScroll: onCarouselScroll
        });

    if (touchDevice) {
        var clientX, clientY, newX, newY;
        $('.carousel').on('touchstart', function (e) {
            if (!$(e.target).hasClass('no-swipe')) {
                clientX = e.originalEvent.touches[0].clientX;
                clientY = e.originalEvent.touches[0].clientY;
                touching = true;
            }
        })
            .on('touchmove', function (e) {
                if (touching) {
                    newX = e.originalEvent.touches[0].clientX;
                    newY = e.originalEvent.touches[0].clientY;
                }
            })
            .on('touchend mouseleave', function () {
                var dx = newX - clientX;
                var dy = newY - clientY;
                if (Math.abs(dx) >= Math.abs(dy)) {
                    if (dx > 20)
                        $('.carousel .left').click();
                    else if (dx < -20)
                        $('.carousel .right').click();
                }
                touching = false;
            });
    }
}


/* Carousel scrolling event */

function onCarouselScroll(idx) {
    var image = $('.carousel li img').eq(idx);
    var color = image.data('title') || image.attr('alt');
    var ctaText = image.data('cta') || $('#choose-btn').data('default-text') || 'Shop Now';
    var linkUrl = image.data('url');

    $('#color-name').html(color);
    $('#choose-btn')
        .html(ctaText)
        .attr('data-color', color);

    if (linkUrl) {
        $('#choose-btn').attr('href', linkUrl);
    }

    //save color change event in GA Event
    //SetGaEventTracking('Browsing Santi Color', 'Click', color);
    //fbq('track', 'Lead', { content_name: 'Santi Home Page', content_category: 'Interact with Santi color carousel' });
}
/*

function onCarouselScroll(idx, linkBaseUrl) {
    var image = $('.carousel li img').eq(idx);
    var color = image.attr('alt');
    var imageUrl = image.attr('src');
    //var linkUrl = linkBaseUrl ? linkBaseUrl + '?color=' + encodeURIComponent(color) : '#';
   var linkUrl = linkBaseUrl;

    $('#color-name').html(color);
    $('#choose-btn')
        .html('Choose ' + color)
        .attr('data-image', imageUrl)
        .attr('data-color', color)
        .attr('href', linkUrl); // Set the link dynamically

}
/*

function onCarouselScroll(idx) {
    var image = $('.carousel li img').eq(idx);
    var color = image.attr('alt');
    var imageUrl = image.attr('src');
    var linkUrl = image.data('link-url');

    $('#color-name').html(color);
    $('#choose-btn')
        .html('Choose ' + color)
        .attr('data-image', imageUrl)
        .attr('data-color', color)
        .attr('href', linkUrl); // Set the link dynamically


}
*/
/* Scroll event handler */

function scrollHandler() {
    var scrollTop = $(this).scrollTop();

    // Header
    if (scrollTop > 1) {
        $('html, #header').addClass('scrolled');
	    // $('header').addClass('site-header-shadow');
    }
    else {
        $('html, #header').removeClass('scrolled');
      	// $('header').removeClass('site-header-shadow');
    }

    // Scroll back to top button
    if (scrollTop > 100)
        $('.back-to-top').fadeIn('slow');
    else
        $('.back-to-top').fadeOut('slow');
}


/* Scroll to a section */

function scrollToSection(target, duration, offsetY) {
    var offset = (offsetY != undefined ? offsetY : 126);
    var time = (duration != undefined ? duration : 1000);
    $('html, body').animate({ scrollTop: $(target).offset().top - offset }, time, 'swing');
}


/* Resize handler */

function resizeHandler() {
    if (carousel) {
        var size = 'wide-screen';
        var width = $(window).innerWidth();
        var height = $(window).innerHeight();
        if (width <= 1440 || height < 1024) size = 'laptop';
        if (width <= 1024 || height < 768) size = 'tablet';
        if (width <= 768 || height < 640) size = 'phablet';
        if (width <= 499 || height < 399) size = 'mobile';

        if (size != screenSize) {
            switch ((screenSize = size)) {
                case 'mobile':
                    carousel.reload(
                        {
                            num: 3,
                            maxWidth: 110,
                            maxHeight: 270,
                            distance: 75,
                            scale: 0.55,
                            animationTime: 350,
                            onScroll: onCarouselScroll
                        });
                    break;

                case 'phablet':
                    carousel.reload(
                        {
                            num: 3,
                            maxWidth: 150,
                            maxHeight: 380,
                            distance: 110,
                            scale: 0.55,
                            animationTime: 350,
                            onScroll: onCarouselScroll
                        });
                    break;

                case 'tablet':
                    carousel.reload(
                        {
                            num: 3,
                            maxWidth: 200,
                            maxHeight: 510,
                            distance: 110,
                            scale: 0.6,
                            animationTime: 400,
                            onScroll: onCarouselScroll
                        });
                    break;

                case 'laptop':
                    carousel.reload(
                        {
                            num: 3,
                            maxWidth: 250,
                            maxHeight: 600,
                            distance: 200,
                            scale: 0.6,
                            animationTime: 400,
                            onScroll: onCarouselScroll
                        });
                    break;

                default:
                    carousel.reload(
                        {
                            num: 3,
                            maxWidth: 300,
                            maxHeight: 750,
                            distance: 160,
                            scale: 0.6,
                            animationTime: 400,
                            onScroll: onCarouselScroll
                        });
                    break;
            }

            $('.carousel').addClass(size);
        }
    }

    // Specs table row constraints
    if ($('.specs-table').length) resizeSpecsTable();
}


/* Table row constraints */

function resizeSpecsTable() {
    var specs = $('.specs-table');
    var rows = ['.specs-heading-1', '.specs-heading-2', '.specs-details'];
    var spacing = 40;

    for (var j = 0; j < rows.length; j++) {
        var cells = specs.find(rows[j]);
        for (var i = 0, height = 0; i < cells.length; i++) {
            height = Math.max(height, $(cells[i]).children().first().height() + spacing);
        }
        cells.css('min-height', Math.ceil(height));
    }
}


/* Update countdown */

function countdown() {
    if (--mins < 0) {
        mins = 59;
        if (--hrs < 0) {
            hrs = 23;
            if (--days < 0) {
                days = hrs = mins = 0;
                clearInterval(timer);
            }
        }
    }
    $('.site-notification #days, .reminder #days').html(days + ' day' + (days > 1 ? 's' : ''));
    $('.site-notification #hrs, .reminder #hrs').html(hrs + ' hour' + (hrs > 1 ? 's' : ''));
    $('.site-notification #mins, .reminder #mins').html(mins + ' minute' + (mins > 1 ? 's' : ''));
}


/* Execution */

$(function () {
    var ua = navigator.userAgent;
    mobile = ua.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
    ios = ua.match(/iP/i);
    android = ua.match(/Android/i);
    touchDevice = ('ontouchstart' in document.documentElement);
    if (mobile) $('html').addClass('mobile');

    initialize();
});


/* Category Carousel */
(function($){
  $(document).ready(function(){
    // init
    $('.cv-carousel').carouselVertical();
    // for moving programmatically the carousel
    // you can do that
    $('.cv-carousel').trigger('goTo', [5]);
    // or that
    $('.cv-carousel').carouselVertical().trigger('goTo', [5]);
  });
})(jQuery);
